import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Flex,
  Text,
  Icon,
  Box,
  useDisclosure,
} from "@chakra-ui/react";
import ArrowIcon from "@root/assets/icons/arrowicon";
import { IconCircle, StyledButton, StyledText } from "./style";
import { useTranslation } from "react-i18next";
export const LogoutModal: React.FC<LogoutModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation("common");
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="rgba(0, 0, 0, 0.4)" />
      <ModalContent
        borderRadius="20px"
        p="44px 26px 26px 26px"
        bg="white"
        w="526px"
        border="4px solid #FFF"
        boxShadow="0px 3px 11px 0px rgba(24, 25, 180, 0.06), 0px 10px 18px 0px rgba(24, 25, 180, 0.06)"
      >
        <Flex direction="column" align="center" gap="24px">
          <IconCircle>
            <ArrowIcon size={32} color="#2F2F34" />
          </IconCircle>
          {/* Title */}
          <Text
            fontSize="24px"
            fontWeight="600"
            color="#2F2F34"
            fontFamily="Poppins"
          >
            {t("logout.logout")}
          </Text>

          <StyledText>{t("logout.confirm")}</StyledText>
        </Flex>

        {/* Buttons */}
        <ModalFooter justifyContent="center" gap="12px" mt="32px" p={0}>
          <StyledButton
            bg="white"
            color="#2F2F34"
            border="2px solid #E6E6E6"
            onClick={onClose}
            _hover={{ bg: "#F5F5F5" }}
          >
            {t("logout.cancel")}
          </StyledButton>
          <StyledButton
            bg="black"
            color="white"
            border="none"
            onClick={onConfirm}
            _hover={{ bg: "#3d3535ff" }}
          >
            {t("logout.yesLogout")}
          </StyledButton>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
